import React, { Component } from 'react';
import { Loader, NoResult } from 'components/misc/loader-utils';
import { cloneDeep, isEqual } from 'lodash';

import analyticService from 'services/analytics';

import dashboardService from '../../publisher/dashboard/dashboard-service';
import StatTable from "../../base/megatable/stat-table";

import './top-articles.scss';

class TopArticles extends Component {
	constructor(props) {
		super(props);

		this.AnalyticService = analyticService;
		this.service = dashboardService;

		this.tableName = 'Top Articles';

		this.state = {
			sortOptions: {
				order_by: 'merchant_revenue',
			},
			loading: true,
			showNoResult: false,
			stats: [],
		};

		this.columns = [
			{
				label: 'Story',
				name: 'edit_name',
				selected: true,
				type: 'string',
			},
			{
				label: 'Date Published',
				name: 'event_date',
				selected: true,
				type: 'string',
			},
			{
				label: 'Clicks',
				name: 'clicks',
				selected: true,
			},
			{
				label: 'Revenue',
				name: 'merchant_revenue',
				selected: true,
				type: 'currency',
			},
		];

		this.sortDisabledFields = ['edit_name'];
		this.defaultSortOptions = {
			order_by: 'merchant_revenue',
		};
	}

	async componentDidMount() {
		this.AnalyticService.trackEvent('Merchant Top Articles', 'Load', this.tableName);
		this.merchId = this.props.merchId;

		await this.queryStats();
	}

	componentDidUpdate(_, prevState) {
		if (!isEqual(prevState.sortOptions, this.state.sortOptions)) {
			this.setState({loading: true}, () => {
				this.queryStats();
			});
		}
	}

	async queryStats() {
		this.setState({
			loading: true,
			totalItems: 0,
		});

		const params = cloneDeep(this.state.sortOptions);
		return this.service.getMerchantTopArticles(this.merchId, params).then((stats) => {
			this.setState({
				loading: false,
				stats: stats,
			});
		}).catch((e) => {
			this.setState({
				loading: false,
				showNoResult: true,
			});
		});
	}

	updateSortParams(columnName, columnLabel) {
		const sortOptions = cloneDeep(this.state.sortOptions);

		if (columnName !== sortOptions.order_by) {
			sortOptions.order_by = columnName;
		}

		const gaDirection = 'Descending';
		const gaLabel = `${this.tableName} Header Sort ${columnLabel} ${gaDirection}`;
		this.AnalyticService.trackEvent('Merchant Dashboard', 'Click', gaLabel);

		this.setState({
			sortOptions: sortOptions,
		}, () => {
			this.queryStats();
		});
	}

	render() {
		const stats = !this.state.loading && !this.state.showNoResult ? (
			<StatTable
				stats={this.state.stats}
				columns={this.columns}
				statType="top-article"
				sortDisabledFields={this.sortDisabledFields}
				sortOptions={this.state.sortOptions}
				updateSortParams={this.updateSortParams.bind(this)}
				tableName={this.tableName}
			/>
		) : null;

		return (
			<div className="top-articles-container">
				<div className="header">
					<div className="top-articles-header">
						Top Stories
					</div>
					<div className="granularity">
						Last 30 days
					</div>
				</div>
				<Loader loading={this.state.loading} />
				<NoResult
					type="top-articles"
					noResult={!this.state.loading && this.state.showNoResult}
				/>
				<div className="merchant-dashboard-table">
					{stats}
				</div>
			</div>
		);
	}
}

export default TopArticles;
